var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('step-progress',{staticStyle:{"max-width":"780px"},attrs:{"line-thickness":2,"active-thickness":2,"passive-thickness":2,"active-color":"#30CB8F","steps":_vm.applySteps,"current-step":_vm.currentStep,"icon-class":"fa fa-check"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }